import {
  ProjectSubmission, ProjectUpdateStorePayload, ProjectUpdate, ContactSubmission, OrganizationSubmission,
} from '../models';
import { SubmissionSource, RequestStatus } from '../models/enums';

const buildCreatePayload = (payload: ProjectUpdateStorePayload): ProjectUpdate => {
  const project: ProjectSubmission = {
    name: payload.projectName,
    estimatedCommencementDate: payload.estimatedCommencementDate,
    number: payload.projectNumber,
    statusAtRegistration: payload.updateProjectStatus,
    source: SubmissionSource.ProjectUpdate,
  };

  const submitter: ContactSubmission = {
    firstName: payload.submittorFirstName,
    lastName: payload.submittorLastName,
    email: payload.submittorEmail,
    phone: payload.submittorPhone,
    source: SubmissionSource.ProjectUpdate,
  };

  const contractor: OrganizationSubmission = {
    name: `${payload.contractorFirstName} ${payload.contractorLastName}`,
    email: payload.contractorEmail,
    addressLine1: payload.contractorAddressLineOne,
    addressLine2: payload.contractorAddressLineTwo,
    city: payload.generalContractorCity,
    state: payload.generalContractorState,
    zip: payload.generalContractorZip,
    country: payload.generalContractorCountry,
    phone: payload.generalContractorPhone,
    fax: payload.generalContractorFax,
    source: SubmissionSource.ProjectUpdate,
  };

  const contractorContact: ContactSubmission = {
    firstName: payload.contractorFirstName,
    lastName: payload.contractorLastName,
    email: payload.contractorEmail,
    phone: payload.generalContractorPhone,
    fax: payload.generalContractorFax,
    source: SubmissionSource.ProjectUpdate,
  };

  const woodworker: OrganizationSubmission = {
    name: payload.woodworkerName,
    addressLine1: payload.woodworkerAddressLineOne,
    addressLine2: payload.woodworkerAddressLineTwo,
    city: payload.woodworkerCity,
    state: payload.woodworkerState,
    zip: payload.woodworkerZip,
    country: payload.woodworkerCountry,
    phone: payload.woodworkerPhone,
    fax: payload.woodworkerFax,
    email: payload.woodworkerEmail,
    source: SubmissionSource.ProjectUpdate,
  };

  const woodworkerContact: ContactSubmission = {
    firstName: payload.woodworkerContactFirstName,
    lastName: payload.woodworkerContactLastName,
    email: payload.woodworkerEmail,
    phone: payload.woodworkerPhone,
    fax: payload.woodworkerFax,
    source: SubmissionSource.ProjectUpdate,
  };


  return {
    project,
    revisedProject: project,
    representing: payload.projectType,
    revisedRepresenting: payload.projectType,
    submitter,
    revisedSubmitter: submitter,
    other: payload.updateProjectStatus == 'Awarded to Other' ? payload.other : '',
    revisedOther: payload.updateProjectStatus == 'Awarded to Other' ? payload.other : '',
    contractor,
    revisedContractor: contractor,
    contractorContact,
    revisedContractorContact: contractorContact,
    woodworker,
    revisedWoodworker: woodworker,
    woodworkerContact,
    revisedWoodworkerContact: woodworkerContact,
    status: RequestStatus.Pending,
  };
};


export default {
  buildCreatePayload,
};